import React from 'react';

const steps = [
  {
    id: '01',
    label: 'Day 1, at your door',
    title: 'Collect at home',
    body: 'The kit arrives in discreet packaging with everything you need. Two minutes in your own bathroom, then drop it in the mail. Postage is prepaid.',
  },
  {
    id: '02',
    label: 'In the lab',
    title: 'We sequence it',
    body: 'DNA sequencing at the lab, read down to the species level rather than a broad-strokes family estimate.',
  },
  {
    id: '03',
    label: 'Every week after',
    title: 'Eat to your results',
    body: 'Your report becomes a weekly nutrition plan: what to add, what to ease off, and the fibers and strains your microbes are missing.',
  },
];

export default function HowItWorks() {
  return (
    <section className="how" aria-labelledby="how-heading">
      <div className="shell">
        <div className="how-header">
          <h2 id="how-heading" className="how-title">
            Three steps, one honest picture of your gut.
          </h2>
          <p className="how-lede">
            No clinic visit, no guesswork, no shelf-blend probiotic that was never meant for you.
          </p>
        </div>
        <ol className="steps">
          {steps.map((step) => (
            <li key={step.id} className={`step step--${step.id}`}>
              <div className="step-marker" aria-hidden="true">{step.id}</div>
              <div>
                <p className="mono-label step-label">{step.label}</p>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-body">{step.body}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
